import { OverviewPeriod } from '@trace/types';
import { DateTime, Duration, DurationUnit } from 'luxon';
import {
  OVERVIEW_DATE_FORMAT,
  OVERVIEW_DURATION_MAP,
  OVERVIEW_STEP_MAP,
} from '../../constants/Overview';

export default (
  period: OverviewPeriod,
): {
  duration: string;
  start: string;
  step: DurationUnit;
} => ({
  duration: OVERVIEW_DURATION_MAP[period],
  start: DateTime.utc()
    .minus(Duration.fromISO(OVERVIEW_DURATION_MAP[period]))
    .toFormat(OVERVIEW_DATE_FORMAT),
  step: OVERVIEW_STEP_MAP[period],
});
